import { render, staticRenderFns } from "./Ellipsis.vue?vue&type=template&id=2d4db33f&scoped=true&"
import script from "./Ellipsis.vue?vue&type=script&lang=js&"
export * from "./Ellipsis.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Ellipsis.vue?vue&type=style&index=0&id=2d4db33f&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2d4db33f",
  null
  ,true
)

export default component.exports